// extracted by mini-css-extract-plugin
module.exports = {"section":"Banner_section__9qBqY","body":"Banner_body__1_TBK","image":"Banner_image__1yXtO","text":"Banner_text__3rE5Q"};